import { useEffect, useRef, useState } from "react";
import { useInView } from "../hooks/useInView";
import { Quote, ExternalLink, Star } from "lucide-react";

const REVIEWS = [
  {
    text: "One of the best doctor in my vicinity. Dr. Samina is very knowledgeable and she has very fine diagnostic ability. Since 10 years she is my family doctor.",
    author: "Nilofer Mulla",
  },
  {
    text: "She is one of the most calm Dr. We came across. She listens to her patients very patiently. She is available all the time. We are taking treatment for our kid and for us for almost 10 to 11 years now and she has very effective way of treatment and effective medicine too. We really thankful to her for her every advice and suggestions whenever needed. One of the best homeopath she is.",
    author: "Pallavi Chopkar",
  },
  {
    text: "Excellent place for Homeopathy treatment the results are good and very effective.",
    author: "Ashwin Joseph",
  },
];

const GOOGLE_REVIEWS_URL =
  "https://www.google.com/maps/place/Silver+Line+Homeo+Care/@18.6698223,73.7284778,17z/data=!4m8!3m7!1s0x3bc2b10992e3a097:0x201bb9ef24e0dec8!8m2!3d18.6698223!4d73.7310527!9m1!1b1!16s%2Fg%2F11wfgf2gnl?authuser=1&entry=ttu&g_ep=EgoyMDI0MDkxOC4xIKXMDSoASAFQAw%3D%3D";

function StarRow() {
  return (
    <div className="flex gap-0.5 stars mb-3">
      {[...Array(5)].map((_, i) => (
        <Star key={i} className="w-4 h-4 fill-current" />
      ))}
    </div>
  );
}

export default function Reviews() {
  const [headRef, headInView] = useInView(0.2);
  const trackRef = useRef(null);
  const [offset, setOffset] = useState(0);
  const [paused, setPaused] = useState(false);

  /* Duplicate reviews for seamless loop */
  const items = [...REVIEWS, ...REVIEWS, ...REVIEWS];

  useEffect(() => {
    if (paused) return;
    const interval = setInterval(() => {
      setOffset((prev) => {
        const cardWidth = 340;
        const gap = 24;
        const step = cardWidth + gap;
        const total = REVIEWS.length * step;
        const next = prev + 0.6;
        return next >= total ? 0 : next;
      });
    }, 16);
    return () => clearInterval(interval);
  }, [paused]);

  return (
    <section id="reviews" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div
          ref={headRef}
          className="text-center mb-12"
          style={{
            opacity: headInView ? 1 : 0,
            transform: headInView ? "translateY(0)" : "translateY(25px)",
            transition: "opacity 0.6s ease, transform 0.6s ease",
          }}
        >
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-primary mb-3">
            Patient Stories
          </span>
          <h2 className="font-display text-3xl sm:text-4xl font-bold text-darktext mb-4">
            What Our Patients Say
          </h2>
        </div>

        {/* Carousel */}
        <div
          className="overflow-hidden"
          onMouseEnter={() => setPaused(true)}
          onMouseLeave={() => setPaused(false)}
          onTouchStart={() => setPaused(true)}
          onTouchEnd={() => setPaused(false)}
        >
          <div
            ref={trackRef}
            className="flex gap-6"
            style={{ transform: `translateX(-${offset}px)`, willChange: "transform" }}
          >
            {items.map((review, i) => (
              <div
                key={i}
                className="flex-shrink-0 w-80 bg-lightbg rounded-2xl p-6 border border-green-100 hover:shadow-lg transition-shadow duration-300"
              >
                <Quote className="w-8 h-8 text-accent mb-3 opacity-60" />
                <StarRow />
                <p className="text-gray-700 text-sm leading-relaxed mb-5 italic">
                  "{review.text}"
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-full bg-primary flex items-center justify-center text-white font-bold text-sm">
                    {review.author[0]}
                  </div>
                  <span className="font-semibold text-darktext text-sm">{review.author}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-10">
          <a
            href={GOOGLE_REVIEWS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-primary hover:bg-darktext text-white font-semibold px-6 py-3 rounded-full transition-all duration-300 hover:scale-105 shadow-md"
          >
            View / Leave a Review on Google
            <ExternalLink className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
}
